import service from "./index.js";
export function newsList(data) {
  return service.get(`/news/list`, { 
    params: data 
  });
}

export function newDetail(data) {
  return service.get(`/news/detail`, { 
    params: data 
  });
}
export function proCategories(data) {
  return service.get(`/product/categories`, { 
    params: data 
  });
}
export function proList(data) {
  return service.get(`/product/list`, { 
    params: data 
  });
}
export function GoodDetail(data) {
  return service.get(`/product/detail`, { 
    params: data 
  });
}
export function formgo(data) {
  console.log(data)
  return service.post(`/contact/submit`, data); 
}
export function getConfig(data) {
  console.log(data)
  return service.get(`/system_config`, data); 
}